<template>
  <div>

    <el-drawer
      :title="title"
      :visible.sync="localVisible"
      :direction="'rtl'"
      size="60%"
      :before-close="handleClose">

      <el-table
        ref="multipleTable"
        :data="mList"

        stripe
        border
        size="mini"
        :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
      >
        <el-table-column label="" width="50" align="center">
          <template slot-scope="scope">
            <el-radio v-model="curShop"  :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          label="文件类型"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
           <span>{{scope.row.source==8?'营业执照':''}}

           {{scope.row.source==9?'身份证':''}}
             {{scope.row.source==10?'银行卡':''}}
                  {{scope.row.source==11?'门店资质':''}}
                  {{scope.row.source==12?'店铺场景':''}}
           </span>
          </template>
        </el-table-column>
        <el-table-column
          label="缩略图"
          width="100"
        >
          <template slot-scope="scope">
            <el-image
              style="height: 60px;width: 80px;"
              :src="scope.row.upload?scope.row.upload.url:''"
              fit="fill"
              class="custom-image"
              :preview-src-list="srcList"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          label="文件名称"
          width="300"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
           <span>
             {{scope.row.upload?scope.row.upload.name:''}}
           </span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件后缀"
          width="80"
          prop="ext"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
           <span>
             {{scope.row.upload?scope.row.upload.ext:''}}
           </span>
          </template>
        </el-table-column>
        <el-table-column
          label="文件大小"
          width="100"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            <span>
             {{scope.row.upload?scope.row.upload.size:''}}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          width="200"
          :show-overflow-tooltip='true'
        >
          <template slot-scope="scope">
            {{scope.row.upload?timeFormat(scope.row.upload.create_time):''}}

          </template>
        </el-table-column>
      </el-table>
      <div class="block" style="margin-top:10px">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-drawer>

  </div>
</template>
<script>
  import moment from "moment";
  export default {
    name:'eFileList',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    }
    ,
    data(){
      return {
        localVisible: this.visible,
        mList:[],
        srcList:[],
        clueLogList:[],
        sourceList:[],
        employeeList:[],
        relationList:[],
        rules: {
          name:[
            { required: true, message: "请输入学员姓名", trigger: 'change' }
          ],
          mobile:[
            { required: true, message: "请输入手机号", trigger: 'change' }
          ],
        },
        addForm:{
          id:'',
          name:'',
          sex:'',
          mobile:'',
          relation_id:'',
          relation_id1:'',
          mobile1:'',
          birthday:'',
          address:'',
          source_id:'',
          creator_id:'',
          follower_id:'',
          remark:'',
          type_id:'',
          clue_id:''
        },

        checkedCourseRs:[],
        selectedIds: [],       // 存储选中的 ID
        prevSelectedIds: [],   // 上一次的选中 ID（用于对比变化）
        selectedIndices: [],   // 当前选中的索引
        addedIndices: [],      // 新增选中的索引
        removedIndices: [],     // 取消选中的索引


        data: [],
        value: [],

        checkAll: false,
        isIndeterminate: false,
        multipleSelection: [],

        keyword:'',
        index:'',
        curShop:'',
        id:'',
        name:'',
        keywords:'',
        fileList:[],

        pageNum:1,
        pageSize:10,
        total:0,
        item:{}
      }
    },
    mounted() {
      // this.DataList();
      // this.getDicList('eduRelation');
      // this.getDicList('eduSource');
      // this.getShopEmployeeList();
    },
    methods:{
      DataList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          // proxy_id:sessionStorage.getItem('proxy_id')
          foreign_id:this.addForm.id,
          pageSize:this.pageSize,
          pageNum:this.pageNum
        }
        this.srcList=[];
        this.$axios.uploadForeignListP(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total=res.data.total;

            if(this.mList.length>0){

              this.mList.map(el=>{
                if(el.upload==null||el.upload.url==null||el.upload.url==''||el.upload.url==undefined){
                    console.log('')
                }else{
                  this.srcList.push(el.upload.url)
                }

              })

            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      handleCheckedCourseChange(){
        let _this=this;
        // 计算新增和取消的 ID
        const added = this.selectedIds.filter(id => !this.prevSelectedIds.includes(id));
        const removed = this.prevSelectedIds.filter(id => !this.selectedIds.includes(id));

        // 计算索引
        this.selectedIndices = this.getSelectedIndices(this.selectedIds);
        this.addedIndices = this.getSelectedIndices(added);
        this.removedIndices = this.getSelectedIndices(removed);

        // 更新 prevSelectedIds
        this.prevSelectedIds = [...this.selectedIds];

        console.log('selectedIds',this.selectedIds)
        console.log('selectedIndices',this.selectedIndices)
        console.log('addedIndices',this.addedIndices)
        console.log('removedIndices',this.removedIndices)

        if(this.removedIndices.length>0&&this.checkedCourseRs.length>0){
          this.removedIndices.map(function (item) {
            for(let i=0;i<_this.checkedCourseRs.length;i++){
              if(_this.checkedCourseRs[i].id==_this.mList[item].id){
                _this.checkedCourseRs.splice(i,1);
                break;
              }
            }
          })
        }
        if(this.addedIndices.length>0){
          this.addedIndices.map(function (item) {
            for(let i=0;i<_this.mList.length;i++){
              if(_this.mList[i].id==_this.mList[item].id){
                let tmp={
                  id:_this.mList[i].id,
                  name:_this.mList[i].name,
                  is_main:0,
                  is_over:0,
                  type_id:_this.mList[i].type_id
                };

                _this.checkedCourseRs.push(tmp);
                break;
              }
            }
          })
        }
        if(_this.checkedCourseRs.length==1){
          _this.checkedCourseRs[0].is_main=1;
        }

      },

      // 根据 ID 数组获取对应的索引
      getSelectedIndices(ids) {
        return this.mList.reduce((indices, item, index) => {
          if (ids.includes(item.id)) {
            indices.push(index);
          }
          return indices;
        }, []);
      },

      handleMouseOver(index) {

        this.checkedCourseRs[index].is_over=1;
        console.log('is_main',this.checkedCourseRs[index].is_main);
        // 在这里添加你的逻辑
      },
      setMain(index){
        for(let i=0;i<this.checkedCourseRs.length;i++){
          if(this.checkedCourseRs[i].is_main==1){

            if(index==i){
                continue
            }else{
              this.checkedCourseRs[index].is_main=1;
              this.checkedCourseRs[i].is_main=0;
              break;
            }
          }
        }


      },
      handleMouseOut(index) {


        this.checkedCourseRs[index].is_over=0;
        console.log('鼠标离开is_main',this.checkedCourseRs[index].is_main);
        console.log('鼠标离开',this.checkedCourseRs[index]);
        // 在这里添加你的逻辑
      },
      filterMethod(query, item) {
        return item.label.indexOf(query) > -1;
      },
      generateData(){
        let _this=this;
        const data = [];
        _this.mList.forEach((item) => {
          data.push({
            label: item.name,
            key: item.id
          });
        });
        this.data=data;
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
        this.checkAll = this.multipleSelection.length === this.mList.length;
        this.isIndeterminate = this.multipleSelection.length > 0 && !this.checkAll;
      },
      getFee(row){
        if(row.fee!=undefined&&row.fee!=null&&row.fee.length>0){
          console.log('666---',row);
          return row.fee[0].items[0].name+"("+row.fee[0].items[0].total_amount+"元"+row.fee[0].items[0].num+"课时)"+"等"+row.fee[0].items.length+'项';//+"("+row.fee.items[0].total_amount+"元"+row.fee.items[0].num+"课时)";
        }else{
          return '';
        }

      },
      handleClose() {
        //this.$refs["form"].resetFields();
        this.closeForm();
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      ok(formName){
        console.log('this.value',this.value)

        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.submit();
          } else {
            return false;
          }
        });

      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time * 1000).format("YYYY-MM-DD HH:mm:ss");
      },
      submit() {
        let _this=this;
        let params={
          name:_this.addForm.name,
          mobile:_this.addForm.mobile,
          // sex:_this.addForm.sex,
          remark:_this.addForm.remark,
          school_id:_this.addForm.school_id,
          birthday:_this.addForm.birthday,
          status:_this.addForm.status,
          relation_id:_this.addForm.relation_id,
        };
        // if(!isNaN(_this.addForm.id)){
        //   params.id=_this.addForm.id;
        // }
        params.company_id=sessionStorage.getItem('company_id');
        params.access_token=sessionStorage.getItem('token');

        this.$axios.eduClueStudentSave(params).then(res=>{
          if(res.code == 200){
            this.$message.success("保存成功");
           // this.formData.courses=this.checkedCourseRs;// this.value;
            this.closeForm();
            this.drawer1=false;
          }

        }).catch(error=>{
          this.$message.error("保存错误");
          console.log(error);
        })
      },
      getDicList(code){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          code:code,
        }
        this.$axios.dicListByPid(param).then(res=>{
          if(res.code == 200){
            if(code=='eduRelation'){
              this.relationList =res.data;
            }else if(code=='eduSource'){
              this.sourceList =res.data;
            }
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      getShopEmployeeList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
        }
        this.$axios.findShopEmployeeList(param).then(res=>{
          if(res.code == 200){
            this.employeeList =res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },


      getClueLogList(){
        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          clue_id: this.addForm.clue_id
        }

        this.$axios.eduClueLogList(param).then(res=>{
          if(res.code == 200){
            this.clueLogList = res.data;
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row,index){
        this.index=index;
        this.id=row.id;
        this.name=row.name;
        // this.formData.name=row.name;
        // this.formData.id=row.id;
        // this.formData.item=this.mList[index];
        this.item=this.mList[index];
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      uploadFile(){

      },
      chooseItem(){
        this.pageNum=1;
        this.total=0;
        this.mList=[];
        this.DataList();
      }
    },
    // 监听
    watch: {
      visible(val) {
        if (val) {
          let _this=this;
          this.localVisible = val;
          if(!isNaN(_this.formData.shop_id)){
            _this.addForm.id=_this.formData.shop_id;
            console.log( _this.addForm.id)
            _this.DataList();
          }


          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }

  .nomain:hover {
    background-color: #f5f5f5 !important;
  }
  .isover{
    color: #E6A23C !important;
  }
  .nomain{

  }
  .noover{
  }
</style>
